<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="activePrompt = true" />
      <!-- <router-link :to="`/invoices/transactions/view/${params.value}`"><feather-icon icon="EyeIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" /></router-link> -->
      <div>
        <vs-prompt
            @cancel="refreshData"
            @accept="updatec"
            @close="close"
            :title="`Edit Category`"
            :is-valid="validName"
            :active.sync="activePrompt">
            <div class="con-exemple-prompt">
              <vs-input placeholder="Name" v-model="newData.cname" class="mt-4 mb-2 w-full" />
              <vue-dropzone ref="zOne"
              id="dropzone"
              :options="dropzoneOptions"
              :auto-process-queue="false"
              :destroyDropzone="true"
              :accepted-file-types='"image/*"'
              :max-files=1
              @vdropzone-thumbnail="fileAdded"
               />
              <vs-textarea placeholder="Description" v-model="newData.cdesc" class="mt-4 mb-2 w-full" />
            </div>
        </vs-prompt>
      </div>
    </div>
</template>

<script>

import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

    export default {
        name: 'CellRendererActions',
          components: {
          vueDropzone: vue2Dropzone
        },
        data(){
          return {
            activePrompt: false,
            dropzoneOptions: {
              url: 'https://httpbin.org/post',
              autoProcessQueue: false,
              thumbnailWidth: 150,
              maxFilesize: 0.5,
            },
            newData: {
              cname: "",
              cdesc: "",
              img: {}
            }
          }
        },
        mounted(){
          this.newData.cname = this.params.data.name
          this.newData.cdesc = this.params.data.desc
        },
        computed:{
          validName(){
            return (this.newData.cname.length > 0)
          }
        },
        methods: {
          fileAdded( file ){
              this.newData.img.data = file.dataURL
              this.newData.img.type = file.type
          },
          updatec(){


          let formData = new FormData()

          if( this.newData.cname == "" || this.newData.cdesc == "" ){
            return
          }


          formData.append('name' , this.newData.cname)
          formData.append('desc' , this.newData.cdesc)


          if( this.newData.img.data != undefined ){
            var binary = atob(this.newData.img.data.split(',')[1]);
            var array = [];
            for(var i = 0; i < binary.length; i++) {
              array.push(binary.charCodeAt(i));
            }

            let img = new Blob([new Uint8Array(array)], {type: this.newData.img.type});

            formData.append('img' , img)

          }


            let local_data = { data: formData, id: this.params.data.id }

            this.$store.dispatch("categoryManagement/updateCategoryMain" , local_data )
            .then( () => {
                this.$vs.notify({
                  color:'success',
                  title:'Category updated',
                  text:'category updation successful'
                })
            })
            .catch( err => {

              this.$vs.notify({
                color:'danger',
                title:'Error',
                text: err.response.data.msg
              })
            })
          },
          refreshData(){
            this.newData = {
              cname: "",
              cdesc: "",
              img: {},
            }
          },
          close(){
            this.newData = {
              cname: "",
              cdesc: "",
              img: {},
            }
          }
        }
    }
</script>
